import { View } from "@react-pdf/renderer";
import {
  ResumePDFText,
} from "components/Resume/ResumePDF/common";
import { styles, spacing } from "components/Resume/ResumePDF/styles";
import type { ResumeAward } from "lib/redux/types";
import { ResumePDFDescriptionBlackText, TemplateEightRightColumnSectionWithSubsections } from "./common";

export const Award = ({
  heading,
  awards,
  themeColor,
  isPDF,
}: {
  heading: string;
  awards: ResumeAward[];
  themeColor: string;
  isPDF: boolean;
}) => {
  return (
    <TemplateEightRightColumnSectionWithSubsections themeColor={themeColor} heading={heading}>
      {awards.map(({ award, issuer, descriptions }, idx) => (
        <View 
          key={idx} 
          wrap={false}
          style={idx !== 0 ? { marginTop: spacing["1"] } : {}} 
        >
          <View
            style={{
              ...styles.flexRow,
              gap: spacing["1"], // spacing["2"]
              alignItems: "center",
            }}
          >
            <ResumePDFText bold={true}>{award}</ResumePDFText>
            <ResumePDFText>{issuer}</ResumePDFText>
          </View>
          <View style={{ ...styles.flexCol, marginTop: spacing["0.5"] }}>
            <ResumePDFDescriptionBlackText items={descriptions} />
          </View>
        </View>
      ))}
    </TemplateEightRightColumnSectionWithSubsections>
  );
};
